import { CREATIVE_TEMPLATE_DEFAULT_ARTBOARD_ID } from "../../../utils/creativeTemplateLayout.js";

export const getReferenceAssetKey = ({ artboardID, slideID } = {}) => {
  const formatKey =
    !artboardID || artboardID === CREATIVE_TEMPLATE_DEFAULT_ARTBOARD_ID
      ? "reference"
      : `reference_${artboardID}`;
  const slide = String(slideID || "").trim();
  return slide ? `${formatKey}__${slide}` : formatKey;
};

export const getSlideScopedAssetKey = ({ key, slideID } = {}) => {
  const base = String(key || "").trim();
  const slide = String(slideID || "").trim();
  if (!base || !slide) return base;
  if (base.endsWith(`__${slide}`)) return base;
  return `${base}__${slide}`;
};

export const assetKeyBelongsToSlide = ({ key, slideID } = {}) => {
  const slide = String(slideID || "").trim();
  if (!slide) return true;
  return String(key || "").endsWith(`__${slide}`);
};

export const filterIncomingCarouselAssets = ({
  assets = {},
  slideIDs = [],
} = {}) => {
  const ids = (slideIDs || [])
    .map((id) => String(id || "").trim())
    .filter(Boolean);
  if (!ids.length) return { ...(assets || {}) };
  return Object.fromEntries(
    Object.entries(assets || {}).filter(([key]) =>
      ids.some((slideID) => assetKeyBelongsToSlide({ key, slideID }))
    )
  );
};

export const referenceAssetIDIsShared = ({
  assets = {},
  assetID,
  exceptKey,
} = {}) => {
  const id = String(assetID || "").trim();
  if (!id) return false;
  return Object.entries(assets || {}).some(
    ([key, asset]) => key !== exceptKey && asset?.assetID === id
  );
};

// A carousel guide belongs to one slide. Cloning referenceAssetRef across
// slides makes every slide paint the same overlay.
export const isolateCarouselSlideGuides = ({
  slides = [],
  assets = {},
} = {}) => {
  let nextAssets = assets || {};
  let changed = false;
  const nextSlides = (slides || []).map((slide) => {
    const slideID = String(slide?.id || "").trim();
    if (!slideID) return slide;
    let nextArtboards = slide?.artboards || {};
    let slideChanged = false;
    Object.entries(slide?.artboards || {}).forEach(([artboardID, artboard]) => {
      const currentKey = String(artboard?.referenceAssetRef || "").trim();
      if (!currentKey) return;
      const canonical = getReferenceAssetKey({ artboardID, slideID });
      if (currentKey === canonical) return;
      const source = nextAssets[currentKey];
      if (!source?.url) return;
      if (!nextAssets[canonical]) {
        nextAssets = {
          ...nextAssets,
          [canonical]: { ...source },
        };
      }
      nextArtboards = {
        ...nextArtboards,
        [artboardID]: {
          ...artboard,
          referenceAssetRef: canonical,
        },
      };
      slideChanged = true;
      changed = true;
    });
    if (!slideChanged) return slide;
    return { ...slide, artboards: nextArtboards };
  });
  if (!changed) return { slides, assets, changed: false };
  return { slides: nextSlides, assets: nextAssets, changed: true };
};
